"use client";

import { useState } from "react";
import type { BillingInterval, PaidPlan } from "@/lib/billing/planConfig";
import { useBilling } from "../hooks/useBilling";
import { IntervalToggle } from "./IntervalToggle";
import { PlanCards } from "./PlanCards";

/** Interval toggle + plan cards. Subscribers start on the interval they pay. */
export function PricingPlans({
  source,
  variant = "page",
  highlight = null,
}: {
  source: string;
  variant?: "page" | "compact";
  highlight?: PaidPlan | null;
}) {
  const { viewer } = useBilling();
  // null until the viewer picks one — until then a subscriber sees the
  // interval they're billed on, everyone else monthly.
  const [picked, setPicked] = useState<BillingInterval | null>(null);
  const interval: BillingInterval = picked ?? viewer.billed?.interval ?? "month";

  return (
    <div className="space-y-5">
      <div className="flex justify-center">
        <IntervalToggle
          value={interval}
          size={variant === "compact" ? "sm" : "md"}
          onChange={setPicked}
        />
      </div>
      <PlanCards interval={interval} source={source} variant={variant} highlight={highlight} />
    </div>
  );
}
